import { render, staticRenderFns } from "./DigitalScriptTagSettings.vue?vue&type=template&id=3c692e60&"
import script from "./DigitalScriptTagSettings.vue?vue&type=script&lang=js&"
export * from "./DigitalScriptTagSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports